import { useContext, createContext } from 'react'

type ThemeType = 'day' | 'night'

export const ThemeContext = createContext<ThemeType>('day')

export const useTheme = (): ThemeType => useContext(ThemeContext)
